import { Component } from "@angular/core";
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss'
  })
  export class ErrorComponent {

  constructor(private liveAnnouncer: LiveAnnouncer){
    this.liveAnnouncer.announce('Login Error');
  }
}